import React from 'react';
import { Youtube, Mail, MapPin } from 'lucide-react';

const Footer = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-[var(--brand-dark)] text-white py-12">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          {/* Brand */}
          <div>
            <h3 className="text-xl font-bold mb-4">Repara Tu Cuerpo</h3>
            <p className="text-white opacity-80 mb-4">
              Ejercicios y automasajes profesionales para aliviar el dolor. 
              Más de 10 años de experiencia en osteopatía.
            </p>
            <a 
              href="https://www.youtube.com/@reparatucuerpo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-white hover:text-[var(--brand-primary)] transition-colors"
            >
              <Youtube size={24} />
              Ver Canal de YouTube
            </a>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Enlaces Rápidos</h4>
            <ul className="space-y-2">
              <li>
                <button 
                  onClick={() => scrollToSection('inicio')}
                  className="text-white opacity-80 hover:opacity-100 hover:text-[var(--brand-primary)] transition-colors"
                >
                  Inicio
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('servicios')}
                  className="text-white opacity-80 hover:opacity-100 hover:text-[var(--brand-primary)] transition-colors"
                >
                  Servicios
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('videos')}
                  className="text-white opacity-80 hover:opacity-100 hover:text-[var(--brand-primary)] transition-colors"
                >
                  Videos
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('blog')}
                  className="text-white opacity-80 hover:opacity-100 hover:text-[var(--brand-primary)] transition-colors"
                >
                  Blog
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('reservas')}
                  className="text-white opacity-80 hover:opacity-100 hover:text-[var(--brand-primary)] transition-colors"
                >
                  Reservar Cita
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('contacto')}
                  className="text-white opacity-80 hover:opacity-100 hover:text-[var(--brand-primary)] transition-colors"
                >
                  Contacto
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contacto</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-2">
                <MapPin size={20} className="flex-shrink-0 mt-0.5" />
                <span className="text-white opacity-80">Escuela Kabat, Madrid<br />Herbolario Tu Equilibrio Personal<br />Calle Murcia 1, Fuenlabrada</span>
              </li>
              <li className="flex items-start gap-2">
                <Mail size={20} className="flex-shrink-0 mt-0.5" />
                <a 
                  href="mailto:reparatucuerpo.rbf@gmail.com" 
                  className="text-white opacity-80 hover:opacity-100 hover:text-[var(--brand-primary)] transition-colors"
                >
                  reparatucuerpo.rbf@gmail.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white border-opacity-20 pt-8 text-center">
          <p className="text-white opacity-70">
            &copy; {new Date().getFullYear()} Repara Tu Cuerpo. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;